export default __webpack_public_path__ + "static/media/pure-r.6f0b5797.webp";